import { en } from "./l10n/en";
import { fr } from "./l10n/fr";
import { pt } from "./l10n/pt";

export const translations = {
    en: en,
    fr: fr,
    pt: pt
  };